import(/* webpackMode: "eager" */ "/home/ubuntu/download/6984e384921dc90014c96dbd/telemarcas/src/app/admin/page.tsx");
